import * as React from 'react';
import { Global } from '@emotion/react';

export const ResetCss = (): JSX.Element => {
  return (
    <Global
      styles={() => ({
        /* http://meyerweb.com/eric/tools/css/reset/
            v2.0 | 20110126
            License: none (public domain)
          */
        'html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed,  figure, figcaption, footer, header, hgroup,  menu, nav, output, ruby, section, summary, time, mark, audio, video':
          {
            margin: 0,
            padding: 0,
            border: 0,
            fontSize: '100%',
            fontWeight: 'inherit',
            verticalAlign: 'baseline',
          },
        /* a11y: adding a11y styles for screen readers only elements */
        '.sr-only': {
          border: 0,
          clip: 'rect(0,0,0,0)',
          clipPath: 'inset(50%)',
          width: '1px',
          height: '1px',
          padding: '0',
          margin: '-1px',
          overflow: 'hidden',
          position: 'absolute',
          whiteSpace: 'nowrap',
        },
        /* HTML5 display-role reset for older browsers */
        'article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section':
          {
            display: 'block',
          },
        'body': {
          lineHeight: 1,
        },
        'ol, ul': {
          listStyle: 'none',
        },
        'blockquote, q': {
          quotes: 'none',
        },
        'blockquote:before, blockquote:after, q:before, q:after': {
          content: 'none',
        },
        'table': {
          borderCollapse: 'collapse',
          borderSpacing: 0,
        },
        ':focus-visible': {
          // a11y: adding focus styles for keyboard navigation and screen readers
          // for more info: https://www.a11yproject.com/posts/2013-01-11-thinking-outside-the-box-a-fresh-look-at-focus-styles/
          outline: '2px solid blue !important',
        },
      })}
    />
  );
};
